import { useState, useEffect, useRef } from "react";

import "./DashboardCell.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import CheckBox from '/src/components/UI/CheckBox/CheckBox';
import TextInput from "/src/components/UI/TextField/TextInput";
import InputBox from "/src/components/UI/InputBox/InputBox"
import DashboardToggle from "../variable/DashboardVariable/DashboardToggle";
import Field from "/src/components/UI/Field/Field"
import DashboardDropdown from "../variable/DashboardVariable/DashboardDropdown";
import DropDown from "/src/components/UI/DropDown/DropDown";
import { Access } from "/src/utils/access";

import dashboardService from "../../services/dashboardService";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import useDropdownDashboard from "../../hooks/useDropdownDashboard"
import {checkNumber} from "../../checkNumber";
function DashboardCell({ data, className, parents, postbackAction, disabled, gridValues, modifyErrorInput, access }) {
    const modifyValue = (val) => {
        postbackAction(data.index, val)
    }
    const toast = useToastDispatchContext();
    const { updateCellValueGrid } = dashboardService;
    const [activeMode, setActiveMode] = useState(data.cell?.active);
    const [errorInput, setErrorInput] = useState(false);
    const [hover, setHover] = useState(false);
    const { dropdownDefaultValue } = useDropdownDashboard(gridValues?.placeholder_format);
    var type = gridValues?.type_variable
    var defaultValue = gridValues?.default_value
    const ref = useRef(null)
    const refInputCell = useRef(null)
    useEffect(() => {
        if (ref.current != null) {
            ref.current.value = data.value;
        }
        if (refInputCell.current != null && switchTimer == null) {
            refInputCell.current.value = data.cell.value;
        }

    }, [data])

    const checkErrorInput = (val) => {
        var regex = new RegExp(gridValues.regex);
        let matched = regex.test(val);
        if (val == "") matched = false
        setErrorInput(!matched);
        modifyErrorInput(parents, matched)

        return !matched
    }

    const checkInput = (text) => {
        if (text != "" && (gridValues.regex == null || gridValues.regex.replace(/\s/g, '').length == 0)) { // no regex
            setErrorInput(false);
            saveData(text);
            return;
        }
        saveData(text, checkErrorInput(text));
    }
    const checkNumberCell = (nb) => {
        saveData(nb, nb.length == 0);
    }

    const [switchTimer, setSwitchTimer] = useState(null);
    const saveData = (value, err) => {
        clearTimeout(switchTimer);
        setSwitchTimer(setTimeout(() => {
            if (err) {
                refInputCell.current.value = data.cell.value;
                setErrorInput(false)
                modifyErrorInput(parents, true)
            }
            else {

                modifyValue(value)
            }
        }, 1500));
    }

    const modifyActiveMode = (checked) => {
        setActiveMode(checked)
        if (checked == false && type == 1) {
            refInputCell.current.value = defaultValue;
        }
        clearTimeout(switchTimer);
        setSwitchTimer(setTimeout(async () => {
            let dataToSend = { index: data.index, block_id: gridValues.block_id, active: checked, value: checked == false ? "NONE" : defaultValue }
            console.log(type);

            const [response, errors] = await updateCellValueGrid(data.index, dataToSend)
            if (errors != null) {
                console.log(errors)
                return;
            }
            toast.success('Variable\'s active mode changed', 'The cell is now ' + (checked ? "enabled" : "disabled"));
        }, 1500));
    }
    return (
        <>

            {
                type == null &&
                <TextInput ref={ref} className={"dashboard_cell_main_container " + (className ? className : "")} placeholder={"Value..."} defaultValue={data.value} onChange={(e) => modifyValue(e.target.value)} disabled={disabled ? disabled : false} />
            }

            {

                type == 0 &&
                <>
                    <div className={"containerToggleCell dashboard_cell_Editor " + (activeMode == false ? "desactivateCell" : "dashboard_cell_hover")} onMouseEnter={(e) => setHover(true)} onMouseLeave={(e) => setHover(false)}>
                        <DashboardToggle data={{ label: data.index, value: data.cell.value, checked: defaultValue }} className={activeMode == false ? "desactiveToggle" : ""} postbackAction={modifyValue}></DashboardToggle>
                        {
                            hover == true && access != Access.Client &&
                            <span style={{ display: 'flex', width: activeMode == false ? "" : "0px" }}>
                                <span className={activeMode == false ? "containerDesactiveMode" : "containerActiveModeToggle"}>
                                    <InputBox id={data.index} setValue={(name, checked) => { modifyActiveMode(checked) }} check={activeMode}></InputBox>
                                </span>
                            </span>
                        }
                    </div>

                </>
            }
            {
                type == 1 &&
                <>
                    <div className={"containerInputCell dashboard_cell_Editor " + (activeMode == false ? "desactivateCell" : "dashboard_cell_hover")} onMouseEnter={(e) => setHover(true)} onMouseLeave={(e) => setHover(false)}>
                        <TextInput ref={refInputCell} style={{ borderColor: (errorInput ? "var(--pink)" : ""), width: hover == true && access != Access.Client ? "110px" : "", display: activeMode == false ? "none" : "block" }} placeholder={"Value..."} defaultValue={data.cell.value} disabled={!activeMode} onChange={(e) => checkInput(e.target.value)} />
                        {
                            hover == true && access != Access.Client &&
                            <span style={{ display: 'flex', width: activeMode == false ? "" : "0px" }}>
                                <span className={activeMode == false ? "containerDesactiveMode" : "containerActiveModeInput"}>
                                    <InputBox id={data.index} setValue={(name, checked) => modifyActiveMode(checked)} check={activeMode} ></InputBox>
                                </span>
                            </span>
                        }
                    </div>

                </>
            }
            {

                type == 2 && dropdownDefaultValue != [] &&
                <div className={"containerDropdownCell dashboard_cell_Editor " + (activeMode == false ? "desactivateCell" : "dashboard_cell_hover")} onMouseEnter={(e) => setHover(true)} onMouseLeave={(e) => setHover(false)}>
                    <div className="dashboard_dropdowns_variable" style={{ pointerEvents: activeMode == false ? "none" : "all", display: activeMode == false ? "none" : "block" }}>
                        <DropDown choices={dropdownDefaultValue} width={hover == true && access != Access.Client ? "130px" : "170px"} defaultChoice={data ? data.cell.value : defaultValue} setValue={(name, value) => saveData(value)} ></DropDown>
                    </div>
                    {
                        hover == true && access != Access.Client &&
                        <span style={{ display: 'flex' }}>
                            <span className={activeMode == false ? "containerDesactiveMode" : "containerActiveModeDropdown"}>
                                <InputBox id={data.index} setValue={(name, checked) => modifyActiveMode(checked)} check={activeMode} ></InputBox>
                            </span>
                        </span>
                    }

                </div>
            }
            {
                type == 4 && // onChange={(e) => checkNumberCell(e.target.value)}
                <>
                    <div className={"containerInputCell dashboard_cell_Editor " + (activeMode == false ? "desactivateCell" : "dashboard_cell_hover")} onMouseEnter={(e) => setHover(true)} onMouseLeave={(e) => setHover(false)}>
                        <TextInput type="number" ref={refInputCell} style={{ borderColor: (errorInput ? "var(--pink)" : ""), width: hover == true && access != Access.Client ? "110px" : "", display: activeMode == false ? "none" : "block" }} className={"full-width input-space cell_number"} placeholder={"Value..."} defaultValue={data.cell.value} disabled={!activeMode} onKeyDown={(e) =>checkNumber(e)}  onChange={(e) => checkNumberCell(e.target.value)}/>
                        {
                            hover == true && access != Access.Client &&
                            <span style={{ display: 'flex', width: activeMode == false ? "" : "0px" }}>
                                <span className={activeMode == false ? "containerDesactiveMode" : "containerActiveModeInput"}>
                                    <InputBox id={data.index} setValue={(name, checked) => modifyActiveMode(checked)} check={activeMode} ></InputBox>
                                </span>
                            </span>
                        }
                    </div>

                </>
            }
        </>
    );
}

export default DashboardCell;